var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelevanceActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b7312c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40,8c-12.15,0-22,9.85-22,22v20c0,12.15,9.85,22,22,22s22-9.85,22-22v-20c0-12.15-9.85-22-22-22ZM57,50c0,9.37-7.63,17-17,17s-17-7.63-17-17v-8h6v8c0,6.07,4.93,11,11,11s11-4.93,11-11v-8h6v8ZM37,54v-26h6v26h-6ZM57,38h-6v-8c0-6.07-4.93-11-11-11s-11,4.93-11,11v8h-6v-8c0-9.37,7.63-17,17-17s17,7.63,17,17v8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelevanceActive);
export default __webpack_public_path__ + "static/media/Relevance-active.65ffcc20e5d1519d47855e2d96830c3c.svg";
export { ForwardRef as ReactComponent };